import LAPrahan25Oct2026Group1 from "../Assets/LA-Prahan-25Oct2026-Group-1.jpeg";
import LAPrahan25Oct20261 from "../Assets/LA-Prahan-25Oct2026-1.jpeg";
import LAPrahan25Oct20262 from "../Assets/LA-Prahan-25Oct2026-2.jpeg";
import LAPrahan12July2026Group1 from "../Assets/LA-Prahan-12July2026-Group-1.jpeg";
import LAPrahan12July20262 from "../Assets/LA-Prahan-12July2026-2.jpeg";
import LAPrahan12July20263 from "../Assets/LA-Prahan-12July2026-3.jpeg";
import LAPrahan12July20264 from "../Assets/LA-Prahan-12July2026-4.jpeg";
import LAPrahan12July20265 from "../Assets/LA-Prahan-12July2026-5.jpeg";
import LAPrahan12July20266 from "../Assets/LA-Prahan-12July2026-6.jpeg";
import LAGroup26April2026 from "../Assets/LA-Group-26April2026.jpeg";
import LAGroup26April20262 from "../Assets/LA-Group-26April2026-2.jpeg";
import LAPrahan26Apr20261 from "../Assets/LA-Prahan-26Apr2026-1.jpeg";
import LAPrahan26Apr20262 from "../Assets/LA-Prahan-26Apr2026-2.jpeg";
import LAPrahan26Apr20263 from "../Assets/LA-Prahan-26Apr2026-3.jpeg";
import LAPrahan26Apr20264 from "../Assets/LA-Prahan-26Apr2026-4.jpeg";
import LAPrahan13Sep2026Group1 from "../Assets/LA-Prahan-13Sep2026-Group-1.jpeg";
import LAPrahan13Sep2026Group2 from "../Assets/LA-Prahan-13Sep2026-Group-2.jpeg";
import LAPrahan13Sep20261 from "../Assets/LA-Prahan-13Sep2026-1.jpeg";
import LAPrahan13Sep20262 from "../Assets/LA-Prahan-13Sep2026-2.jpeg";
import LAPrahan13Sep20263 from "../Assets/LA-Prahan-13Sep2026-3.jpeg";

const LosAngelesPhotos = [
  // ── October 25, 2026 ────────────────────────────  
  {
    img: LAPrahan25Oct20261,
    alt: "Participants playing table tennis — Parkinson's Neuro-Wellness session, October 25, 2026, California Table Tennis",
  },
  {
    img: LAPrahan25Oct2026Group1,
    alt: "Group photo — Parkinson's Neuro-Wellness session, October 25, 2026, California Table Tennis",
  },
  {
    img: LAPrahan25Oct20262,
    alt: "Participants playing table tennis — Parkinson's Neuro-Wellness session, October 25, 2026, California Table Tennis",
  },
  // ── September 13, 2026 ──────────────────────────
  {
    img: LAPrahan13Sep2026Group1,
    alt: "Group photo — Parkinson's Neuro-Wellness session, September 13, 2026, California Table Tennis",
  },
  {
    img: LAPrahan13Sep2026Group2,
    alt: "Group photo — Parkinson's Neuro-Wellness session, September 13, 2026, California Table Tennis",
  },
  {
    img: LAPrahan13Sep20261,
    alt: "Warm-up stretches — Parkinson's Neuro-Wellness session, September 13, 2026, California Table Tennis",
  },
  {
    img: LAPrahan13Sep20262,
    alt: "Warm-up stretches — Parkinson's Neuro-Wellness session, September 13, 2026, California Table Tennis",
  },
  {
    img: LAPrahan13Sep20263,
    alt: "Participants playing table tennis — Parkinson's Neuro-Wellness session, September 13, 2026, California Table Tennis",
  },
  // ── July 12, 2026 ───────────────────────────────
  {
    img: LAPrahan12July2026Group1,
    alt: "Los Angeles Group - July 12, 2026",
  },
  {
    img: LAPrahan12July20262,
    alt: "Los Angeles July 12, 2026 - 2",
  },
  {
    img: LAPrahan12July20263,
    alt: "Los Angeles July 12, 2026 - 3",
  },
  {
    img: LAPrahan12July20264,
    alt: "Los Angeles July 12, 2026 - 4",
  },
  {
    img: LAPrahan12July20265,
    alt: "Los Angeles July 12, 2026 - 5",
  },
  {
    img: LAPrahan12July20266,
    alt: "Los Angeles July 12, 2026 - 6",
  },
  {
    img: LAGroup26April2026,
    alt: "Los Angeles Group - April 26, 2026",
  },
  {
    img: LAGroup26April20262,
    alt: "Los Angeles Group - April 26, 2026 - 2",
  },
  {
    img: LAPrahan26Apr20261,
    alt: "Los Angeles April 26, 2026 - 1",
  },
  {
    img: LAPrahan26Apr20262,
    alt: "Los Angeles April 26, 2026 - 2",
  },
  {
    img: LAPrahan26Apr20263,
    alt: "Los Angeles April 26, 2026 - 3",
  },
  {
    img: LAPrahan26Apr20264,
    alt: "Los Angeles April 26, 2026 - 4",
  },
];

export default LosAngelesPhotos;